import clsx from "clsx";
import React from "react";
import BreadcrumbPill from "web/react/components/breadcrumb-pill/breadcrumb-pill";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./feeds-filters-breadcrumb-pills.module.css";

export interface BreadcrumbPillsProps {
    breadcrumbs: Breadcrumb[];
    className?: string;
}

export interface Breadcrumb {
    id: string;
    label: string;
    to: string;
    onClick(): void;
    hideIcon?: boolean;
}

export function BreadcrumbPills({
    className,
    breadcrumbs,
}: BreadcrumbPillsProps): null | JSX.Element {
    if (!breadcrumbs?.length) {
        return (
            <span className={styles.pillsEmpty}>
                {gettext("feed.breadcrumbs.no_filters.label")}
            </span>
        );
    }

    return (
        <ul className={clsx(styles.pills, className)}>
            {breadcrumbs.map((breadcrumb) => (
                <li className={styles.pill} key={breadcrumb.id}>
                    <BreadcrumbPill
                        onClick={breadcrumb.onClick}
                        title={breadcrumb.label}
                        href={breadcrumb.to}
                        hideIcon={breadcrumb.hideIcon}
                    />
                </li>
            ))}
        </ul>
    );
}
